var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCriticalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart-crack-solid 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.52969 2.41185C7.80391 2.19857 9.08906 2.30794 10.2812 2.70169L13.0047 6.93997L8.88125 11.0634C8.79922 11.1454 8.75 11.2603 8.75547 11.3806C8.76094 11.5009 8.81016 11.6103 8.89766 11.6923L15.0227 17.3798C15.1813 17.5275 15.4273 17.5384 15.5969 17.3962C15.7664 17.254 15.8047 17.0134 15.6898 16.8275L12.3867 11.4626L17.3469 7.32826C17.4891 7.21341 17.5383 7.01654 17.4781 6.847L16.2312 3.37982C17.7898 2.46654 19.6437 2.11107 21.4648 2.41732C25.2383 3.04076 28 6.30013 28 10.1228V10.44C28 12.7095 27.0594 14.8806 25.3969 16.4283L15.5148 25.654C15.1047 26.0368 14.5633 26.2501 14 26.2501C13.4367 26.2501 12.8953 26.0368 12.4852 25.654L2.60312 16.4283C0.940625 14.8806 0 12.7095 0 10.44V10.1228C0 6.30013 2.76172 3.04075 6.52969 2.41185Z",
    fill: "#6210CC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalIcon);
export default __webpack_public_path__ + "static/media/critical_icon.40e75454c429134b7b16a1030bab80eb.svg";
export { ForwardRef as ReactComponent };